import React from 'react';
import { Link } from 'react-router-dom';

import ClientSection from '../components/ClientComponents/ClientSection';
import VideoSection from '../components/Sections/VideoSection';
import TextAboutSection from '../components/Misc/TextAboutSection';
import CallToAction from '../components/Misc/CallToAction';
import ProjectHeader from '../components/Headers/ProjectHeader';
import ProjectsHighlights from '../components/ProjectComponents/ProjectsHighlights';

const Home1 = () => {
    return (
        <>
            {/* Video section - start */}
            <VideoSection />
            {/* Video section - end */}

            {/* About section - start */}
            <TextAboutSection />
            {/* About section - end */}

            {/* Projects section - start */}
            <div className="projects">
                <div className="projects-wrapper">
                    <ProjectHeader
                        heading={'Recent work'}
                        paragraph={
                            <>
                                Our recent work focuses on{' '}
                                <Link className="projects-inline-link" to="/OurWork">
                                    building products
                                </Link>{' '}
                                where experience leads the way.
                            </>
                        }
                    />
                    <ProjectsHighlights count={4} />
                    {/*<ProjectsSection />*/}
                    <CallToAction 
                        wrapperClass='projects-footer bg-black'
                        headingClass='light-1'
                        heading={
                            <>
                                Have an idea?
                                <br />
                                Let’s explore it together.
                            </>
                        }
                        buttonText="Contact Us"
                        buttonLink="/Contact"
                        buttonType="1"
                    />
                </div>
            </div>
            {/* Projects section - end */}

            {/* Testimonials section 
            <Testimonial />
            */}

            {/* Clients section - start */}
            <ClientSection />
            {/* Clients section - end */}
        </>
    );
};

export default Home1;
